import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Stack, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import Illustration, { type IllustrationProps } from './_illustration';

interface IllustrationCaptionProps extends IllustrationProps {
	caption: string;
}

const styles = cssMap({
	container: {
		paddingBlockStart: token('space.400'),
		paddingBlockEnd: token('space.400'),
	},
});

/**
 * Lottie animation component with caption
 */
export const IllustrationCaption = ({ caption, ...props }: IllustrationCaptionProps) => {
	return (
		<Stack space="space.100" xcss={styles.container}>
			<Illustration
				xcss={props.xcss}
				lottieFile={props.lottieFile}
				size={props.size}
				label={props.label}
				hasBorder={props.hasBorder}
				hasSpacing={false}
			/>
			<Text size="small" align="center" color="color.text.subtlest">
				{caption}
			</Text>
		</Stack>
	);
};

export default IllustrationCaption;
